import { Button } from "@/components/ui/button";
import moment from "moment";
import { useApiList } from "@/queries";

export function RrtReportingSummaryHandler({ currentExport, data, dataSave, exportToExcel }) {
  const { data: users } = useApiList(currentExport == "rrt reporting" ? "/v2/user" : null, [currentExport]);
  const userByKey = new Map();
  users?.forEach((u) => {
    if (u.alias) userByKey.set(String(u.alias), u);
    if (u.id) userByKey.set(String(u.id), u);
    if (u.name) userByKey.set(String(u.name), u);
    // nested staff codes if API returns relations
    if (u.logistic_staff?.alias) userByKey.set(String(u.logistic_staff.alias), u);
    if (u.logistic_staff?.code) userByKey.set(String(u.logistic_staff.code), u);
    if (u.repair_center?.alias) userByKey.set(String(u.repair_center.alias), u);
    if (u.repair_center_engineer?.alias) userByKey.set(String(u.repair_center_engineer.alias), u);
    if (u.repair_center_engineer?.code) userByKey.set(String(u.repair_center_engineer.code), u);
  });
  const resolveLogCode = (val) => {
    if (!val) return "-";
    const hit = userByKey.get(String(val));
    if (hit) return hit.logistic_staff?.code || hit.logistic_staff?.alias || hit.alias || String(val);
    return String(val);
  };
  const resolveRcCode = (val) => {
    if (!val) return "-";
    const hit = userByKey.get(String(val));
    if (hit)
      return (
        hit.repair_center?.code ||
        hit.repair_center_engineer?.code ||
        hit.repair_center?.alias ||
        hit.repair_center_engineer?.alias ||
        hit.alias ||
        String(val)
      );
    return String(val);
  };

  if (currentExport == "rrt reporting") {
    const exportData = dataSave.repair_request_tickets
      .filter((obj) => {
        if (data.date_from && data.date_to) {
          return moment(obj.created_at).isBetween(
            data.date_from,
            data.date_to,
          );
        } else {
          return true;
        }
      })
      .filter((obj) => {
        if (data.part_platform_id) {
          return (
            obj.part_repairs.part_repairables?.part_details
              ?.part_platform_id == data.part_platform_id
          );
        } else {
          return true;
        }
      })
      .map((obj) => {
        const findWork = (codes) =>
          obj.rrt_status_works.find((sw) => codes.includes(sw.status_work_code));
        const openTime = findWork(["ONR", "RRO"])?.created_at;
        const startTime = obj.rrt_status_works.find(
          (sw) => sw.status_work_code === "RRP",
        )?.created_at;
        const responTime = moment.duration(
          moment(startTime).diff(moment(openTime)),
        );
        const responTimeHours = Math.floor(responTime.asHours());
        const responTimeMinutes =
          Math.floor(responTime.asMinutes()) - responTimeHours * 60;
        const responTimeSeconds =
          Math.floor(responTime.asSeconds()) -
          responTimeHours * 60 * 60 -
          responTimeMinutes * 60;
        const responTimeFormat =
          responTimeHours + ":" + responTimeMinutes + ":" + responTimeSeconds;

        const stopTime = obj.rrt_status_works.find(
          (sw) => sw.status_work_code === "RRF",
        )?.created_at;
        const repairTime = moment.duration(
          moment(stopTime).diff(moment(startTime)),
        );
        const repairTimeHours = Math.floor(repairTime.asHours());
        const repairTimeMinutes =
          Math.floor(repairTime.asMinutes()) - repairTimeHours * 60;
        const repairTimeSeconds =
          Math.floor(repairTime.asSeconds()) -
          repairTimeHours * 60 * 60 -
          repairTimeMinutes * 60;
        const repairTimeFormat =
          repairTimeHours + ":" + repairTimeMinutes + ":" + repairTimeSeconds;

        const returnTime = obj.rrt_status_works.find(
          (sw) => sw.status_work_code === "RPT",
        )?.created_at;
        const completionTime = moment.duration(
          moment(returnTime).diff(moment(stopTime)),
        );
        const completionTimeHours = Math.floor(completionTime.asHours());
        const completionTimeMinutes =
          Math.floor(completionTime.asMinutes()) - completionTimeHours * 60;
        const completionTimeSeconds =
          Math.floor(completionTime.asSeconds()) -
          completionTimeHours * 60 * 60 -
          completionTimeMinutes * 60;
        const completionTimeFormat =
          completionTimeHours +
          ":" +
          completionTimeMinutes +
          ":" +
          completionTimeSeconds;

        return {
          "RRT No": obj.rr_ticket_no,
          "LOG Code": resolveLogCode(findWork(["ONR", "RRO"])?.updated_by),
          "RC Code": resolveRcCode(
            obj.rrt_status_works.find((sw) => sw.status_work_code === "RRF")?.updated_by,
          ),
          "Open Time": findWork(["ONR", "RRO"])?.created_at
            ? moment(findWork(["ONR", "RRO"])?.created_at)
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "Return Time": obj.rrt_status_works.find(
            (sw) => sw.status_work_code === "RPT",
          )?.created_at
            ? moment(
                obj.rrt_status_works.find(
                  (sw) => sw.status_work_code === "RPT",
                )?.created_at,
              )
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "Respon Time":
            responTime > 0 ? responTimeFormat : "Not Started Yet",
          "Repair Time":
            repairTime > 0 ? repairTimeFormat : "Not Stopped Yet",
          "Completion Time":
            completionTime > 0 ? completionTimeFormat : "Not Returned Yet",
        };
      });

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `rrt_summary_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
